<template>
  <v-app>
    <v-main>
      <v-progress-linear v-if="isLoading" indeterminate />
      <template v-else>
        <SideBar v-if="isAuthenticated && showSidebar" />
        <router-view></router-view>
      </template>
    </v-main>
  </v-app>
</template>

<script>
import SideBar from './components/SideBar.vue';
import { jwtDecode } from 'jwt-decode';

function jwtDecodeFallback(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(payload);
  } catch (e) {
    console.error('App.vue - jwtDecode fallback failed:', e);
    return null;
  }
}

export default {
  components: { SideBar },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    isAuthenticated() {
      const token = localStorage.getItem('authToken');
      if (!token) {
        console.log('App.vue - No token found in localStorage');
        return false;
      }

      let tokenToDecode = token;
      if (typeof token === 'string' && token.length > 1 && token.startsWith('"') && token.endsWith('"')) {
        console.warn('App.vue - Token wrapped in quotes. Removing them.');
        tokenToDecode = token.substring(1, token.length - 1);
      }

      try {
        let decoded;
        try {
          decoded = jwtDecode(tokenToDecode);
        } catch (decodeError) {
          console.error('App.vue - jwt-decode failed, using fallback:', decodeError);
          decoded = jwtDecodeFallback(tokenToDecode);
        }

        if (!decoded) {
          throw new Error('App.vue - Failed to decode token');
        }

        const currentTime = Math.floor(Date.now() / 1000);
        if (decoded.exp < currentTime) {
          console.log('App.vue - Token expired');
          localStorage.removeItem('authToken');
          return false;
        }

        console.log('App.vue - Token is valid');
        return true;
      } catch (error) {
        console.error('App.vue - Error decoding token:', error);
        localStorage.removeItem('authToken');
        return false;
      }
    },
    showSidebar() {
      const protectedRoutes = [
        '/dashboard',
        '/models',
        '/sales',
        '/reports',
        '/adjustments',
        '/calendar',
        '/payments',
        '/configuration',
      ];
      return protectedRoutes.includes(this.$route.path);
    },
  },
  async mounted() {
    console.log('App.vue - Mounted');
    // Wait for router to be ready to ensure route is settled
    await this.$router.isReady();
    this.isLoading = false;
  },
};
</script>